// extracted by mini-css-extract-plugin
export default {"content":"Search-module__content--vqHXE","item":"Search-module__item--ic4Ad","item__name":"Search-module__item__name--yZtjA","item__date":"Search-module__item__date--Fco09"};